'use strict';

import Vue from 'vue';
import Vuex from 'vuex';

import state from './state';
import mutations from './mutations';
import actions from './action';
import getters from './getters';

import so from './modules/so';
import email from './modules/email';
import crm from './modules/crm';
import account from './modules/account';

Vue.use(Vuex);

const store = new Vuex.Store({
  strict: false,
  actions,
  getters,
  mutations,
  state,
  modules: {
    so,
    email,
    crm,
    account
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js